enum Page {
  First = 'First',
  Second = 'Second',
  Third = 'Third',
  Forth = 'Forth',
}

export default Page;
